import React from "react";
import { Box } from "@mui/material";
import CircularProgress from "@mui/material/CircularProgress";
import Typography from "@mui/material/Typography";

export default function CircularProgressMUI({unit, value }) {
  return (
    <Box sx={{ position: "relative", display: "inline-flex" }}>
      <CircularProgress
        variant="determinate"
        value={value}
        color={
        unit===''?
        'success':
          value >= 75
            ? "success" // Green for values 75 and above
            : value >= 50
            ? "warning" // Yellow for values 50 to 74
            : "error" // Red for values below 50
        }
      />
      <Box
        sx={{
          top: 0,
          left: 0,
          bottom: 0,
          right: 10,
          position: "absolute",
          display: "flex",
          flexDirection: "column",
          alignItems: "center",
          justifyContent: "center",
        }}
      >
        <Typography
          variant="caption"
          component="div"
          sx={{ color: "#FFFFF" }}
        >{`${Math.round(value)}${unit}`}</Typography>
      </Box>
    </Box>
  );
}
